import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { findAll } from '@fretadao/f-js-dom';
import { groupBy, isBlank } from '@fretadao/f-js-utils'

/**
 * Clear an HTML formulary based on a button
**/
application.register('clear-filters', class extends Controller {
  static targets = ['button'];

  TEXT_FIELDS_KINDS = [
    'date',
    'datetime-local',
    'email',
    'hidden',
    'month',
    'number',
    'search',
    'tel',
    'text',
    'time',
    'url',
    'week'
  ];

  REMOVE_FIELDS_BY_NAME = ['page'];

  connect() {
    this.buttonTarget.addEventListener('click', (_event) => this.#clearFields(this.buttonTarget.form));
  }

  #clearFields(form) {
    const fieldsByType = this.#fieldsByType(form);
    this.#clearSelectFields(fieldsByType['select-one']);
    this.#clearCheckBoxes(fieldsByType['checkbox']);
    this.#clearTextFields(fieldsByType);
    this.#removeFieldsByName(fieldsByType);
    this.#clearMultipleFields(fieldsByType['select-multiple']);
  }

  #clearTextFields(fieldsByType) {
    const clearField = field => field.value = '';

    this.TEXT_FIELDS_KINDS
      .filter(textFieldKind => textFieldKind in fieldsByType)
      .forEach(textFieldKind => fieldsByType[textFieldKind].forEach(clearField));
  }

  #clearCheckBoxes(fields) {
    if (isBlank(fields)) return;

    fields.forEach(field => field.checked = false);
  }

  #clearSelectFields(fields) {
    if (isBlank(fields)) return;

    const clearField = field => {
      const emptyOption = Object.keys(field.options).find(position => isBlank(field.options[position].value));
      field.selectedIndex = emptyOption;
    }

    fields.forEach(clearField);
  }


  #fields(form) {
    return findAll('input', form).concat(findAll('select', form));
  }

  #fieldsByType(form) {
    const clearableFields = this.#fields(form).filter(this.#clearableField);

    return groupBy(clearableFields, field => field.type);
  }

  #clearableField(field) {
    return isBlank(field.dataset.skipClearing);
  }

  #removeFieldsByName(fieldsByType){
    this.REMOVE_FIELDS_BY_NAME.forEach((fieldName) => {
      Object.values(fieldsByType).forEach((fields) => {
        fields.filter((field) => field.name === fieldName).forEach((field) => field.remove());
      })
    })
  }

  // This solution works properly with both type of fields (default and select2 fields)
  #clearMultipleFields(field) {
    $(field).val(null).trigger('change');
  }
});

